class Utils {
  constructor() { }

  gup(url, parameterName) {
    parameterName = parameterName.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var finResults = [];

    var results = null;
    do {
      if(results != null) {
        url = url.replace(results[0], "");
        finResults.push(results[1]);
      }

      var regex = new RegExp("[\\?&]" + parameterName + "=([^&#]*)");
      var results = regex.exec(url);
    } while(results != null);

    return finResults.length ? finResults : null;
  };

  formatDate(strDate) {
    if(strDate === "NAN" || strDate === "AUTO" || strDate === "TEXT" || strDate == null) return strDate;

    var strDateSplitted = strDate.split(".");
    var day = strDateSplitted[0];
    var month = strDateSplitted[1];

    return day.replace(/^0/, "") + (App.lang === "en" ? " " + i18n[month] : ". " + i18n[month].toLowerCase());
  };

  formatMonth(strDate) {
    var strDateSplitted = strDate.split(".");
    var month = strDateSplitted[1];

    return (App.lang === "en" ? i18n[month] : i18n[month].toLowerCase());
  };

  InfoDate(text, id, dateId) {
    var re = new RegExp(id, "g")
    if(App.date.length > 1 && App.date[0][dateId] != null && App.date[1][dateId] != null) {
      var datesRangeI18n = i18n.datesRange.replace("###DATE-A###", "<strong>" + this.formatDate(App.date[0][dateId]) + "</strong>")
                                          .replace("###DATE-B###", "<strong>" + this.formatDate(App.date[1][dateId]) + "</strong>");
      text = text.replace(re, datesRangeI18n);
    } else {
      text = text.replace(re, "<strong>" + this.formatDate(App.date[0][dateId]) + "</strong>");
    }
    return text;
  };

  InfoDateRange(text, dateId1, dateId2) {
    if(App.date.length > 1 && App.date[0][dateId1] != null && App.date[0][dateId2] != null && App.date[1][dateId1] != null && App.date[1][dateId2] != null) {
      var datesRangeI18n = i18n.datesRange.replace("###DATE-A###", "<strong>" + this.formatDate(App.date[0][dateId1]) + "&ndash;" + this.formatDate(App.date[0][dateId2]) + "</strong>")
                                          .replace("###DATE-B###", "<strong>" + this.formatDate(App.date[1][dateId1]) + "&ndash;" + this.formatDate(App.date[1][dateId2]) + "</strong>");
      text = text.replace("###PORTAL-OPENS-DEADLINE###", datesRangeI18n);
    } else {
      text = text.replace("###PORTAL-OPENS-DEADLINE###", "<strong>" + this.formatDate(App.date[0][dateId1]) + "&dash;" + this.formatDate(App.date[0][dateId2]) + "</strong>");
    }
    return text;
  };

  checkWithinRange(d) {
    moment.updateLocale("en", { week: {
      dow: 1, // First day of week is Monday
      doy: 4  // First week of year must contain 4 January (7 + 1 - 4)
    }});

    window.nowss = moment.utc(d).tz("Europe/Oslo");
    var year = d.getFullYear();

    for (var i = 0; App.date.length; i++) {
      if (!App.date[i]) return false;

      var dateOpens = App.date[i]["portal-opens"];
      if (!dateOpens) return false;

      var dateOpensDay = dateOpens.split(".")[0];
      var dateOpensMonth = dateOpens.split(".")[1];

      var dateCloses = App.date[i]["deadline"];
      if (!dateCloses) return false;

      var dateClosesDay = dateCloses.split(".")[0];
      var dateClosesMonth = dateCloses.split(".")[1];

      var dateOpensMoment = moment.utc(year + '-' + dateOpensMonth + '-' + dateOpensDay).tz("Europe/Oslo").subtract(1, 'days');
      var dateClosesMoment = moment.utc(year + '-' + dateClosesMonth + '-' + dateClosesDay).tz("Europe/Oslo").add(1, 'days');

      if (nowss.isBetween(dateOpensMoment, dateClosesMoment, 'day', '[]')) {
        return true;
      }
    }
    return false;
  }
}

export default new Utils;
